"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyApi = exports.TaxonomyTypeEnum = exports.TAXONOMY_API_ERROR = exports.TAXONOMY_POSTFIX = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
exports.TAXONOMY_POSTFIX = 'Taxonomy';
exports.TAXONOMY_API_ERROR = 'TAXONOMY_API_ERROR';
var TaxonomyTypeEnum;
(function (TaxonomyTypeEnum) {
    TaxonomyTypeEnum["ProductsTaxonomy"] = "productsTaxonomy";
    TaxonomyTypeEnum["NewsCategoriesTaxonomy"] = "newsCategoriesTaxonomy";
    TaxonomyTypeEnum["EventCategoriesTaxonomy"] = "eventCategoriesTaxonomy";
    TaxonomyTypeEnum["MarketsTaxonomy"] = "marketsTaxonomy";
    TaxonomyTypeEnum["DownloadTypeTaxonomy"] = "downloadTypeTaxonomy";
    TaxonomyTypeEnum["SegmentsTaxonomy"] = "segmentsTaxonomy";
    TaxonomyTypeEnum["SubSegmentsTaxonomy"] = "subSegmentsTaxonomy";
    TaxonomyTypeEnum["SolutionsTaxonomy"] = "solutionsTaxonomy";
    TaxonomyTypeEnum["ApplicationsTaxonomy"] = "applicationsTaxonomy";
    TaxonomyTypeEnum["BrandsDhstaxonomy"] = "brandsDHSTaxonomy";
    TaxonomyTypeEnum["BrandsDdstaxonomy"] = "brandsDDSTaxonomy";
    TaxonomyTypeEnum["ProductTypesDdstaxonomy"] = "productTypesDDSTaxonomy";
    TaxonomyTypeEnum["EnclosuresDdstaxonomy"] = "enclosuresDDSTaxonomy";
    TaxonomyTypeEnum["CareersTaxonomy"] = "careersTaxonomy";
    TaxonomyTypeEnum["CountriesTaxonomy"] = "countriesTaxonomy";
    TaxonomyTypeEnum["MegatrendsTaxonomy"] = "megatrends";
    TaxonomyTypeEnum["LanguagesTaxonomy"] = "languagesTaxonomy";
})(TaxonomyTypeEnum || (exports.TaxonomyTypeEnum = TaxonomyTypeEnum = {}));
var TaxonomyApi = /** @class */ (function (_super) {
    tslib_1.__extends(TaxonomyApi, _super);
    function TaxonomyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Override from BaseApi
    TaxonomyApi.prototype.throwException = function (message, responseData, _name) {
        if (_name === void 0) { _name = ''; }
        _super.prototype.throwException.call(this, message, responseData, exports.TAXONOMY_API_ERROR);
    };
    TaxonomyApi.prototype.updateStorage = function (data) {
        this.setDataToStorage(data, null);
    };
    return TaxonomyApi;
}(app_1.BaseApi));
exports.TaxonomyApi = TaxonomyApi;
